import React, { PropTypes } from 'react';
import Modal from '../Modal';
import Form, { FormBody, FormActions, TextInput, SelectInput, DateInput } from '../Form';
import { inject, observer } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import moment from 'moment';
import { token } from '../../libs/localStorage';
import FormMultiSelectInput from '../FormMultiSelectInput';
import { tripApi } from '../../actions/api';

@inject('ticketStore', 'stationStore', 'userStore', 'ticketStatusStore', 'ticketReasonStore', 'ticketActionStore', 'rolePermissionStore', 'serverStore','folderStore','tripStore')
@observer
export default class TripAdd extends React.Component {

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  slug = this.props.slug ? '/' + this.props.slug : '/monitoring/trip/tabular';

  @observable item = {
    // user_id: +token.getDecoded().id,
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    planned_by:null,
    region:''
  };

  @observable multiUserOptions = [];
  @action onChangeStartDate = e => this.item.start_date = e.target.value;
  @action onChangeEndDate = e => this.item.end_date = e.target.value;
  @action onChangePlannedBy = e => this.item.planned_by = +e.target.value;
  @action onChangeRegion = e =>this.item.region = e.target.value

  @action onCommutatorsSelect = (item) => {
    item.value = !item.value;
    this.multiUserOptions.filter(t => +t.id === +item.id).forEach(t => t.value = item.value);
  }

  componentDidMount() {
    const { userStore, ticketStore } = this.props;

    if (userStore.items && userStore.items.length > 0) {
      if (this.multiUserOptions.length === 0) {
        const newMultiUserOptions = userStore.items.map(item => ({
          id: item.id,
          name: item.name,
          email: item.email,
          label: item.name ,
          value: false
        }));
        this.multiUserOptions = newMultiUserOptions;
      }
    }
  }

  handleSave = e => {
    e.preventDefault();
    const { rolePermissionStore, tripStore } = this.props;
    const { notify, router } = this.context;
    const hasUserPermission = rolePermissionStore.validateRole('view user');

    if (!this.item.start_date || !this.item.end_date || (!hasUserPermission ? false : !this.item.planned_by)) {
      notify.error({ message: 'missing fields' });
      return;
    }

    const commutatorsId = this.multiUserOptions.filter(i => i.value == true).map(j => j.id)
    const apiData = {
      ...this.item,
      commutators:commutatorsId
    }

    // tripApi.postTripPlan(apiData).then((res) => {
    // tripStore.createItem(apiData).then((res) => console.log(res,"resss"))
    tripStore.createItem(apiData).then((res) => {
      notify.success({ message: 'TripPlan Created' });
      router.push(this.slug);
    }).catch(err=> {
      notify.error({ message: err.message });
      console.log(err) 
    })

  };

  render() {
    const { stationStore, userStore,ticketStore, rolePermissionStore, serverStore, folderStore} = this.props;
    if (serverStore.items.length == 0) serverStore.fetchItems()
      if (folderStore.items.length == 0) folderStore.fetchItems()
    const station = stationStore.findById(this.item.station_id);
    const hasUserPermission = rolePermissionStore.validateRole('view user');

    return (
      <Modal slug={this.slug} title='Add Trip' isSaving={ticketStore.isSaving}>
        <Form>
          <FormBody>        
          <DateInput label='Start Date' value={this.item.start_date} onChange={this.onChangeStartDate} />
          <DateInput label='End Date' value={this.item.end_date} onChange={this.onChangeEndDate} />
          <TextInput label={'Region'} value={this.item.region} onChange={this.onChangeRegion} />
          <FormMultiSelectInput id='user-multi-select' label='Commutators' options={this.multiUserOptions} optionClicked={this.onCommutatorsSelect} loading={false} hideSelectAll hideClearAll />
            {hasUserPermission && <SelectInput
              id={'Planned By'}
              label={'Planned By'}
              value={this.item.planned_by}
              options={userStore.items}
              onChange={this.onChangePlannedBy}
              fields={{
                label: 'name',
                value: 'id',
              }}
            />}
        

          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Trips/TripAdd.js